module.exports = __webpack_public_path__ + "img/buy-eggs-infograph.1c79e616.svg";